import { isString } from 'lodash';

export const getHashingMetadata = (payload) => (
  isString(payload) ? JSON.parse(payload) : payload
);

export default () => {};
